export enum OrderLinesTarget {
  ORDER_BOOK = 'order-book',
  PRODUCTION_SCHEDULE = 'production-schedule'
}
